export default __webpack_public_path__ + "static/cork-midsummer-1c266bcace47af29b49bb9e083d85c71.webm";